<template>
    <div>
        <v-select v-model="selectedItem" :items="items" :label="label" clearable @input="setValue($event)" :menu-props="{maxHeight: '400px'}" :rules="rules">
            <template slot="selection" slot-scope="data">
                <avatar class="mr-2" :color="data.item.value == 'custom' ? color : data.item.value" :size="24" border />
                {{$translate(data.item.text)}}
            </template>

            <template slot="item" slot-scope="data">
                <v-list-item v-on="data.on" v-bind:attrs="data.attrs" dense @click="itemClicked(data.item.value)" :input-value="data.item.value == color || (data.item.value == 'custom' && data.item.value == 'custom' && (color && color[0] == '#'))">
                    <v-icon
                        v-if="data.item.value == 'custom' && (!color || color[0] != '#')"
                        class="mr-2"
                    >
                        mdi-select-color
                    </v-icon>
                    <avatar v-else class="mr-2" :color="data.item.value == 'custom' ? color : data.item.value" :size="24" border />
                    {{$translate(data.item.text)}}
                </v-list-item>
            </template>

            <template slot="append">
                <slot name="append"></slot>
            </template>
        </v-select>

        <toolbox-window v-if="showColorPicker && type == 'toolbox'" :label="label" close @close="showColorPicker=false" center>
            <v-card>
                <v-color-picker v-bind:value="color" v-on:update:color="setValue($event.hexa)" mode="hexa" />

                <v-card-actions>
                    <v-btn
                        class="zoezi-button-thin"
                        color="zoezi-edit-color"
                        outlined
                        @click="setValue(colorBeforePick); showColorPicker = false"
                    >
                        {{$translate('Undo')}}
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        class="zoezi-button-thin"
                        color="zoezi-edit-color"
                        @click="showColorPicker = false"
                    >
                        {{$translate('Close')}}
                    </v-btn>

                </v-card-actions>
            </v-card>
        </toolbox-window>

        <bottom-dialog v-else-if="showColorPicker && type == 'bottomdialog'" v-model="showColorPicker" :dialog="!$vuetify.breakpoint.mobile" max-width="300px" >
            <v-card>
                <v-color-picker v-bind:value="color" v-on:update:color="setValue($event.hexa)" mode="hexa" />

                <v-card-actions>
                    <v-btn
                        class="zoezi-button-thin"
                        color="zoezi-edit-color"
                        outlined
                        @click="setValue(colorBeforePick); showColorPicker = false"
                    >
                        Ångra
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn
                        class="zoezi-button-thin"
                        color="zoezi-edit-color"
                        @click="showColorPicker = false"
                    >
                        Stäng
                    </v-btn>

                </v-card-actions>
            </v-card>
        </bottom-dialog>
    </div>

</template>

<script>
import ToolboxWindow from '../components/ToolboxWindow.vue'
import Avatar from '../components/Avatar.vue'
import BottomDialog from '../components/BottomDialog.vue'
export default {
    name: 'ColorSetting',

    props: {
        value: {},
        label: {},
        hint: {},
        type: {
            type: String,
            default: 'toolbox'
        },
        colorList: {
            type: Array,
            default: null
        },
        rules: {
            type: Array,
            default: () => []
        },
        showDefaultColors: {
            type: Boolean,
            default: true
        }
    },

    components: {
        ToolboxWindow,
        Avatar,
        BottomDialog
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.color = this.alphaify(value);
                let found = this.items.find(item => item.value == value);
                this.selectedItem = value ? (found ? found.value : 'custom') : null;
            }
        },
        showColorPicker(show) {
            if (show) {
                this.colorBeforePick = this.color;
                if (!this.color) {
                    this.color = this.items[0].value
                }
                if (this.color && this.color[0] != '#') {
                    this.setValue(this.colors[this.color]);
                }
            }
        }
    },

    data: () => ({
        color: null,
        showColorPicker: false,
        selectedItem: null,
        colorBeforePick: null
    }),
    methods: {
        setValue(color) {
            if (color == 'custom') {
                return;
            }
            this.color = this.alphaify(color);
            this.$emit('input', this.dealphaify(this.color));
        },
        dealphaify(x) {
            if (x) {
                if (x.length == 9 && x.substring(7) == 'FF') {
                    return x.substring(0, 7);
                }
                return x;
            }

            return null;
        },
        alphaify(x) {
            if (x && x.length == 7 && x[0] == '#') {
                x += 'FF';
            }
            return x;
        },
        clear() {
            this.setValue(null);
        },
        itemClicked(value) {
            if (value == 'custom') {
                this.showColorPicker = true;
            }
        }
    },
    computed: {
        items() {
            if (this.colorList) {
                return this.colorList.concat([{value: 'custom', text: 'Custom color'}]);
            }
            if (!this.showDefaultColors) {
                return [{value: 'custom', text: 'Custom color'}];
            }
            return [
                {value: 'primary', text: 'Primary'},
                {value: 'secondary', text: 'Secondary'},
                {value: 'accent', text: 'Accent'},
                {value: 'warning', text: 'Warning'},
                {value: 'info', text: 'Information'},
                {value: 'success', text: 'Success'},
                {value: 'error', text: 'Error'},
                {value: 'primarytext', text: 'Color of text written on primary color'},
                {value: 'custom', text: 'Custom color'}
            ]
        },
        colors() {
            return this.$vuetify.theme.currentTheme;
        }
    }
}
</script>
